import React from "react";

import i18n from "utils/i18n";
import _ from 'lodash'
import { useSelector } from 'react-redux'
import { dataConstants } from 'services/redux/data/constants'
import Form from 'components/molecules/Form'
import { FormFieldsConstants } from 'utils/constants/form-constants';
import ThemedBlock from 'components/atoms/ThemedBlock'
import NoResultsView from 'components/atoms/NoResultsView'
import EmployeeValues from 'scenes/home/more/_functions/Employee'

const SettingsTabs = () => {
	
	const _employee = useSelector( state => {
		return state.data[dataConstants.EMPLOYEE];
	} )
	const _languages = useSelector( state => {
		return state.data[dataConstants.LANGUAGES];
	} )
	
	const data = {
		language_guid: _.get( _employee, ['language', 'guid'], null )
	}
	
	const languageOptions = _.map( _.sortBy( _languages ), language => {
		return (
			{
				value: language.guid,
				label: language.name
			}
		);
	});
	
	const formFields = [
		{
			name: 'language_guid',
			label: i18n.t('form.fields.language.title'),
			hint: i18n.t('form.fields.language.description'),
			type: FormFieldsConstants.SELECT,
			options: languageOptions
		},
	];

	if( _.size( formFields ) === 0 ) {
		return <NoResultsView>{ i18n.t('page.profile.settings.no_settings') }</NoResultsView>;
	}
	
	return (
		<ThemedBlock
			mediumPadding
			shadow>

			<Form
				values={ data }
				fields={ formFields }
				onChange={ EmployeeValues.onChangeEmployee }
				hideSubmit={ true }
			/>
		</ThemedBlock>
	);
}

export default SettingsTabs;
